export default "__VITE_ASSET__DW1aGlZx__"